module.exports = __webpack_public_path__ + "img/home_01.084a2cb8.png";